import { setTrackerConfig } from '../../utils/analytics';
import trackingConfig from './trackingConfig';
import setDataLayer from './setDataLayer';
import trackingActions from './trackingActions';

const initializeTrackerConfig = () =>
  setTrackerConfig({
    initialConfigs: trackingConfig(),
    actions: trackingActions,
    callback: setDataLayer,
  });

export default initializeTrackerConfig;
